import { APP_GOOGLE_URL, APP_STORE_URL } from "@/constants/app-store";
import { Box } from "@mui/material";
import { FC } from "react";
import badgeAppStore from "@/assets/images/badge-app-store.svg";
import badgeGoogleStore from "@/assets/images/badge-google-play.svg"


export const AppStoreBadges: FC = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
      <Box
        component="a"
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ display: "flex", height: 40 }}
      >
        <img src={badgeAppStore} alt="Download on the App Store" style={{ height: 40, width: "auto" }} />
      </Box>
      <Box
        component="a"
        href={APP_GOOGLE_URL}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ display: "flex", height: 40 }}
      >
        <img src={badgeGoogleStore} alt="Get it on Google Play" style={{ height: 40, width: "auto" }} />
      </Box>
    </Box>
  );
};

